export const getPath = () => {
  const dashboardsPath = '/dashboards';
  const pathNames = window.location.pathname.split('/dashboards');
  return `${dashboardsPath}${pathNames[pathNames.length - 1]}`;
};
